import { motion } from "framer-motion";
import { ChevronRight } from "lucide-react";

const HERO_IMG =
  "https://images.unsplash.com/photo-1592838064575-70ed626d3a0e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBzZW1pJTIwdHJ1Y2slMjBoaWdod2F5fGVufDB8fHx8MTc4NzE3MTEyMXww&ixlib=rb-4.1.0&q=85";

export const Hero = () => {
  return (
    <section id="home" data-testid="hero-section" className="relative min-h-[100vh] flex items-end overflow-hidden">
      <img
        src={HERO_IMG}
        alt="Semi truck on the highway"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-black/60" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-transparent to-black/40" />

      <div className="relative z-10 max-w-7xl mx-auto w-full px-5 md:px-8 pb-24 pt-40">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="font-display text-sm md:text-base font-semibold uppercase tracking-[0.3em] text-orange-500 mb-6"
          data-testid="hero-eyebrow"
        >
          Build The Asset. Own The Company.
        </motion.p>

        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="font-display text-5xl md:text-7xl font-bold uppercase leading-[0.95] tracking-tighter text-white max-w-5xl"
          data-testid="hero-headline"
        >
          Own A Trucking Company.
          <span className="block text-orange-500">We'll Run It.</span>
        </motion.h1>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.2 }}
          className="mt-8 max-w-2xl space-y-4 text-base md:text-lg text-neutral-300"
          data-testid="hero-subtext"
        >
          <p>
            Start and own a real trucking business without having to become a trucking operations
            expert. I Stay Trucking helps build the company and manages the day-to-day operating
            infrastructure behind it — from dispatch and driver coordination to compliance,
            settlements and back-office operations.
          </p>
          <p className="text-white font-semibold">
            You own the business. We operate it.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.3 }}
          className="mt-10 flex flex-col sm:flex-row gap-4"
        >
          <a
            href="#get-started"
            data-testid="hero-primary-cta"
            className="inline-flex items-center justify-center gap-2 bg-orange-500 px-8 py-5 font-display text-base md:text-lg font-semibold uppercase tracking-wider text-white transition-all duration-200 hover:bg-orange-600 hover:-translate-y-1"
          >
            See If You Qualify
            <ChevronRight size={20} />
          </a>
          <a
            href="#get-started"
            data-testid="hero-secondary-cta"
            className="inline-flex items-center justify-center border border-neutral-500 px-8 py-5 font-display text-base md:text-lg font-semibold uppercase tracking-wider text-white transition-all duration-200 hover:border-orange-500 hover:text-orange-500 hover:-translate-y-1"
          >
            Book A Discovery Call
          </a>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.55 }}
          className="mt-14 flex flex-wrap items-center gap-x-4 gap-y-2 font-display text-sm md:text-base font-semibold uppercase tracking-[0.2em] text-neutral-400"
          data-testid="hero-journey-strip"
        >
          <span>Own The Company</span>
          <ChevronRight size={16} className="text-orange-500" />
          <span>We Operate It</span>
          <ChevronRight size={16} className="text-orange-500" />
          <span className="text-white">You Build The Asset</span>
        </motion.div>
      </div>
    </section>
  );
};
